import { useMutation } from 'react-query'

import { addHighlight } from '../api/live-section'

/**
 * Add a highlight for a webinar.
 */
export function useAddHighlightMutation(liveId: number) {
  return useMutation({
    mutationKey: ['add-highlight', liveId],
    mutationFn: () => addHighlight(liveId),
  })
}
